import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 1400px;
  width: 100%;
  margin: 10px auto;
  font-family: 'Montserrat', 'Open Sans', sans-serif;
`;

export const Title = styled.h1`
  font-size: 32px;
  font-family: 'Montserrat', 'Open Sans', sans-serif;
`;

export const ComparisonContainer = styled.div`
  dispaly: flex;
  justify-content: space-between;
  margin: 20px auto;
  max-width: 900px;
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/styles.js